module.exports = __webpack_public_path__ + "static/media/excelcopy.38c0767b.svg";